"use client";

import { Animal } from "@/features/Animals/AnimalColumns.ts";
import { Image } from "@heroui/image";

export function AnimalImages({ animal }: { animal: Animal }) {
  // Filter out the image URLs that are actual URLs (not
  // character arrays)
  // const imageUrls = animal?.imageUrls.filter(
  //   (url) => typeof url === "string" && url.startsWith("https://"),
  // );

  // const handlePrevious = () => {
  //   setCurrentImageIndex((prev) =>
  //     prev === 0 ? imageUrls.length - 1 : prev - 1,
  //   );
  // };
  //
  // const handleNext = () => {
  //   setCurrentImageIndex((prev) =>
  //     prev === imageUrls.length - 1 ? 0 : prev + 1,
  //   );
  // };

  if (!animal.image) {
    return (
      <div className="flex flex-col items-center justify-center p-8 text-center">
        <p className="text-muted-foreground">
          No images available for this animal.
        </p>
      </div>
    );
  }

  return (
    // <div className="w-screen space-y-4">
    <div className="w-screen p-2 relative flex flex-col justify-center items-center overflow-hidden rounded-lg border">
      <Image
        isBlurred
        loading={"lazy"}
        isZoomed
        alt={`${animal.name} - Image `}
        // className="object-fill h-full transition-all duration-300"
        className="w-full h-full object-cover z-50"
        src={animal.image || "/placeholder.svg"}
      />
    </div>
    // </div>
  );
}
